<template>
  <div class="v-radio-question-wrap" style="width: 100%">
    <el-table
      :ref="name"
      :data="data"
      :default-sort="{order: 'ascending'}"
      @sort-change="sortChange"
      border
      style="width: 100%">
      <template v-for="(item, index) in fields">
        <el-table-column
          v-if="(!item.hide && !hideFileds.includes(item.prop)) || showFileds.includes(item.prop)"
          :sortable="item.sort ? 'custom' : false"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :align="item.align"
          :header-align="item.headerAlign">
          <template slot-scope="scope">
            <template v-if="item.type == 'visitorLink'">
              <el-button @click="linkVisitor(scope.row)" type="text" size="small">{{$t('linkVisitor')}}</el-button>
            </template>
            <template v-if="item.prop === 'action'">
              <slot name="todo-action" :data="scope"></slot>
            </template>
            <template v-else-if="item.slot === true">
              <slot :name="item.prop + '-action'" :data="scope"></slot>
            </template>
            <template v-else>
              <template v-if="item.prop == 'corporate'">
                <slot name="cell-td" :data="scope">
                  <template v-if="scope.row['corporateName'] && scope.row['corporateEnName']">
                    {{scope.row['corporateName']}} | {{scope.row['corporateEnName']}}
                  </template>
                  <template v-else-if="!scope.row['corporateName'] && !scope.row['corporateEnName']"></template>
                  <template v-else>
                    {{scope.row['corporateName']}} {{scope.row['corporateEnName']}}
                  </template>
                </slot>
              </template>
              <template v-if="item.prop == 'inviteState'">
                <slot name="cell-td" :data="scope">
                  <template v-if="scope.row[item.prop] == 'APPROVE'">
                    {{$t('APPROVE')}}
                  </template>
                  <template v-else-if="scope.row[item.prop] == 'PENDING'">
                    {{$t('PENDING')}}
                  </template>
                </slot>
              </template>
              <template v-else>
                <slot name="cell-td" :data="scope" :prop="item.prop">
                  <template v-if="language == 'en'">
                    {{cellData(scope.row[item.propEn]) ? scope.row[item.propEn] : (cellData(scope.row[item.prop]) ? scope.row[item.prop] : '--')}}
                  </template>
                  <template v-else>{{cellData(scope.row[item.prop]) ? scope.row[item.prop] : (cellData(scope.row[item.propEn]) ? scope.row[item.propEn] : '--')}}</template>
                </slot>
              </template>
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="pageChange"
      :page-size="pageSize"
      :current-page="page"
      :total="total">
    </el-pagination>
  </div>
</template>
<script>
import i18n from '@/utils/i18n'
import { mapGetters } from 'vuex'

export default {
  props: {
    // 字段名
    fields: {
      type: Array,
      default: () => [
        {
          prop: 'name',
          label: i18n.t('visitorName'),
          width: 100,
          align: 'center',
        },
        {
          prop: 'corporate',
          label: i18n.t('companyName'),
          width: 180,
          align: 'center',
        },
        {
          prop: 'post',
          label: i18n.t('post'),
          align: 'center',
        },
        {
          prop: 'country',
          label: i18n.t('country'),
          sort: true,
          align: 'center',
        },
        {
          prop: 'province',
          label: i18n.t('province'),
          align: 'center',
        },
        {
          prop: 'city',
          label: i18n.t('city'),
          align: 'center',
        },
        {
          prop: 'times',
          label: i18n.t('numOfVisits'),
          sort: true,
          align: 'center',
        },{
          prop: 'status',
          label: i18n.t('hStatus'),
          align: 'center',
          hide: true
        },{
          prop: 'action',
          label: i18n.t('todoAction'),
          type: 'visitorLink',
          align: 'center',
          width: 150
        },
      ]
    },
    // 数据
    data: {
      type: Array,
      default: () => []
    },
    // 表格类型
    type: {
      type: String,
      default: ''
    },
    // 一页显示几条数据
    pageSize: {
      type: Number,
      default: 10
    },
    // 总条数
    total: {
      type: Number,
      default: 0
    },
    // 页码
    page: {
      type: Number,
      default: 1
    },
    // 隐藏字段
    hideFileds: {
      type: Array,
      default: () => []
    },
    showFileds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      name: 'table_' + Date.now()
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  mounted() {
  },
  methods: {
    sortChange({column, prop, order}) {
      this.$emit('sortChange', column, prop, order, this.type)
    },
    pageChange(page) {
      this.$emit('pageChange', page, this.type)
    },
    linkVisitor(data) {
      this.$emit('linkVisitor', data)
    },
    clearSort() {
      this.$refs[this.name].clearSort()
    },
    cellData(data) {
      if (data || data === 0) {
        return true
      }
      return false
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>
